import { createContext, useContext } from 'react'

/**
 * Optional "leave the expertise editor" action. When the expertise tool is
 * embedded in the chatapp (as the affaire-detail Expertise subtab), the host
 * provides this so WorkspaceShell can render a "Retour à l'app" button in the
 * sidebar. In the standalone app no provider is mounted → value is null → the
 * button is not rendered. Context (not prop drilling) because WorkspaceShell
 * sits under V2Page → step components, several layers deep.
 */
export const ExpertiseBackContext = createContext<(() => void) | null>(null)

export const useExpertiseBack = (): (() => void) | null =>
  useContext(ExpertiseBackContext)
